module.exports = __webpack_public_path__ + "static/media/white_delete.375855cd.svg";